
import {Component, Vue, Watch} from "vue-property-decorator";
import {queryModule, studyDefinitionModule, studyInstitutesModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import {formatDate} from "@/auxillary/date-format";
import {canSeeInstituteQueries, canSeeQueries} from "@/components/query/QueryPermissions";
import QueriesMenu from "@/components/query/menu/QueriesMenu.vue";
import QueryCreateMenuItem from "@/components/query/menu/QueryCreateMenuItem.vue";
import QueryCreateDialog from "@/components/query/dialogs/QueryCreateDialog.vue";
import IStudyInstituteShortDto = MdbsCore.IStudyInstituteShortDto;
import IStudyPatientShortDto = MdbsCore.IStudyPatientShortDto;
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import IQueryTypeDefinitionDto = MdbsCore.IQueryTypeDefinitionDto;
import IQueryCreateDto = MdbsCore.IQueryCreateDto;
import IStudyInstituteOverviewDto = MdbsCore.IStudyInstituteOverviewDto;
import {canSeeStudyInstituteTrail} from "@/auxillary/audittrail.permissions";

@Component({
  methods: {canSeeStudyInstituteTrail},
  components: {QueriesMenu, QueryCreateMenuItem, QueryCreateDialog},
  filters: {
    formatDate
  }
})
export default class StudyInstitutesOverview extends Vue {
  patientHeaders: any = [
    {text: 'Identifier', value: 'identifier'},
    {
      text: 'Registrierdatum',
      value: 'registrationDate',
      sort: (d1: Date, d2: Date) => new Date(d1).getTime() > new Date(d2).getTime() ? 1 : -1
    },
    {text: 'Ansehen', value: 'actions', sortable: false, width: "100px", align: "center"}
  ];
  staffHeaders: any = [
    {text: 'Name', value: 'displayName'},
    {
      text: 'eMail',
      value: 'email',
    }
  ];

  patientFooterOptions: any = {
    'items-per-page-options': [25, 50]
  };
  staffFooterOptions: any = {
    'items-per-page-options': [25, 50]
  };

  patientOptions: any = {
    sortBy: ['registrationDate'],
    sortDesc: [true]
  };
  staffOptions: any = {};

  panel = null;

  @Watch('panel', {immediate: true, deep: true})
  private async onPanelChanged() {
    if (this.panel == undefined || this.panel == null)
      return;

    const instituteIndex = this.panel ?? 0;
    if (this.institutes.length <= instituteIndex)
      return;

    console.log(this.institutes[instituteIndex]?.id);
    await queryModule.loadInstituteQueries(this.institutes[instituteIndex]?.id)
  }

  get institutes(): Array<IStudyInstituteOverviewDto> {
    const institutes = deepCopy(studyInstitutesModule.studyInstitutesOverview);

    return institutes.sort((i1, i2) => i2.identifier! < i1.identifier! ? 1 : -1);
  }

  get patients() {
    return (institute: IStudyInstituteShortDto): Array<IStudyPatientShortDto> => {
      return studyInstitutesModule.studyInstitutesOverview.find(si => si.id == institute.id)?.patients ?? [];
    }
  }

  get staffUsers() {
    return (institute: IStudyInstituteShortDto) => {
      return studyInstitutesModule.studyInstitutesOverview.find(si => si.id == institute.id)?.assignedUsers ?? [];
    }
  }

  async openPatient(patient: IStudyPatientShortDto) {
    await this.$router.push({
      name: "patient",
      params: {patientId: patient.id}
    }).catch();
  }

  async mounted() {
    await studyInstitutesModule.loadStudyInstitutesOverview();
  }

  // QUERIES
  showCreateQuery = false;
  createQueryDefinition: IQueryTypeDefinitionDto | null = null;
  createInstituteQueryId: string = "";

  get myVisibleQueryTypeDefinitions(): Array<QueryTypeDefinitionDto> {
    return studyDefinitionModule.myVisibleQueryTypeDefinitions;
  }

  get myCreatableQueryTypeDefinitions(): Array<QueryTypeDefinitionDto> {
    return studyDefinitionModule.myCreatableQueryTypeDefinitions;
  }

  get hasCreatableQueryDefinitions() {
    return canSeeQueries && this.myCreatableQueryTypeDefinitions.length > 0;
  }

  get queryListResponse() {
    return queryModule.instituteQueryListResponse;
  }

  get hasVisibleQueries() {
    return canSeeInstituteQueries && (this.queryListResponse?.items?.length ?? 0) > 0;
  }

  handleCreateQuery(queryDefinition: IQueryTypeDefinitionDto, instituteId: string) {
    this.createQueryDefinition = deepCopy(queryDefinition);
    this.createInstituteQueryId = instituteId;
    this.showCreateQuery = true;
  }

  async handleSaveCreateQuery(queryCreate: IQueryCreateDto) {
    await queryModule.createQueryForInstitute({instituteId: this.createInstituteQueryId, createDto: queryCreate})
    this.showCreateQuery = false;
  }

  currentUserIsAssigned(institute: IStudyInstituteOverviewDto) {
    return institute.currentUserIsAssigned;
  }

  async openAuditTrail(studyInstituteId: string){

    await this.navigate("studyinstituteaudittrail", {
      studyInstituteId: studyInstituteId
    });
  }
  async navigate(name: string, params: any) {
    try {
      return await this.$router.push({name, params});
    } catch (error) {
      if (error.name !== 'NavigationDuplicated')
        throw error;
    }
  }
}
